import { defineStore } from "pinia"
import { GuestChargingService } from "@/services/guest-charging-service"
import { DynamicConfig, RegistrationDocument } from "@/models/common"
import { FeatureState } from "@/models/enums"
interface DictionaryState {
  registrationDocuments: RegistrationDocument[]
  registrationDocumentsState: FeatureState
  dynamicConfig?: DynamicConfig
  dynamicConfigState: FeatureState
}

export const useDictionaryStore = defineStore(
  "dictionary",
  {
    state: (): DictionaryState => ({
      registrationDocuments: [],
      registrationDocumentsState: FeatureState.Initial,
      dynamicConfig: undefined,
      dynamicConfigState: FeatureState.Initial
    }),

    getters: {
      getRegistrationDocuments: (state) =>
        state.registrationDocuments.filter(
          (doc: RegistrationDocument) => !doc.isOptional
        ),

      getTermsDataIsLoading: (state) =>
        state.registrationDocumentsState === FeatureState.Loading,

      getDynamicConfigIsLoading: (state) =>
        state.dynamicConfigState === FeatureState.Loading
    },

    actions: {
      async fetchRegistrationDocuments(languageCode: string) {
        try {
          this.registrationDocumentsState = FeatureState.Loading

          const { data } = await GuestChargingService.getRegistrationDocuments(
            languageCode
          )

          this.registrationDocuments = data
          this.registrationDocumentsState = FeatureState.Success
        } catch (error) {
          this.registrationDocumentsState = FeatureState.Error
          console.error(error)
        }
      },

      async fetchDynamicConfig() {
        try {
          this.dynamicConfigState = FeatureState.Loading

          const { data } = await GuestChargingService.getConfig()

          this.dynamicConfig = data
          this.dynamicConfigState = FeatureState.Success
        } catch (error) {
          this.dynamicConfigState = FeatureState.Error
          console.error(error)
        }
      }
    }
  }
)
